export const _tagTypes = [
    "OffertsConfigApi",
];
